import React from 'react';

import { CardNumberElement } from '@stripe/react-stripe-js';
import type { StripeCardNumberElementChangeEvent } from '@stripe/stripe-js';

type Props = {
	onChange?: (event: StripeCardNumberElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export function CardNumberElementWrapper({ onChange, onFocus, onBlur }: Props): React.JSX.Element {
	return (
		<CardNumberElement
			options={{ style: { base: { fontSize: '16px' } } }}
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
		/>
	);
}
